import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import DataTable from 'components/DataTable';
import DisclaimerText from 'components/DisclaimerText';

import Button from 'primitives/Button';

import { useSyndicateAnalyticsData } from '.';

const SchemeMetrics: FC = () => {
  const navigate = useNavigate();
  const { analytics, syndicateId } = useSyndicateAnalyticsData();

  return (
    <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center justify-between px-6 pt-6">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Scheme Metrics</h2>
          <p className="mt-1 text-sm text-gray-500">
            Scheme-wise performance built from raw capital, distribution, exit, and valuation data.
          </p>
        </div>
        <Button
          variant="secondary"
          onClick={() => navigate(`/syndicate-dashboard/${syndicateId}/analytics/dpi-breakdown`)}
        >
          View DPI Breakdown
        </Button>
      </div>
      <div className="mt-2 mb-4 px-6">
        <DisclaimerText
          message={
            <>
              <p>Metrics are computed from scheme level data.</p>
              <p>
                Companies held across multiple schemes - for example, following an entity flip,
                share swap, or similar restructuring - may be reflected more than once in aggregate
                figures
              </p>
            </>
          }
        />
      </div>
      <div className="px-6 pb-6 pt-4">
        <DataTable
          data={analytics.schemeMetrics}
          searchFields={['schemeName']}
          columns={[
            {
              label: 'Scheme',
              fieldName: 'schemeName',
            },
            {
              label: 'Invested Capital',
              fieldName: 'investedCapital',
              type: 'CURRENCY',
            },
            {
              label: 'XIRR',
              fieldName: 'xirr',
              type: 'PERCENTAGE',
            },
            {
              label: 'TVPI',
              fieldName: 'tvpi',
              type: 'MULTIPLE',
            },
            {
              label: 'RVPI',
              fieldName: 'rvpi',
              type: 'MULTIPLE',
            },
          ]}
          emptyListTitle="No scheme analytics yet"
          emptyListDescription="Once this syndicate has finalized investments, the scheme-level metrics will appear here."
        />
      </div>
    </section>
  );
};

export default SchemeMetrics;
